<template>
  <!-- 日期插件 -->
  <div class="rqbox" :style="{'background':bgColor}">
    <div class="title">
      <span class="titlename">{{title}}</span>
      <span class="titletips">
        <van-icon name="info-o" />{{titlermark}}
      </span>
    </div>
    <div class="rqlist" v-if="dateList.length > 0">
      <div class="riitem" v-for="(item,index) in dateList" :key="index" @click="checkDate(item)"
        :class="checkdate==item?'riitem-active':''">
        <div class="itemname">
          <span>{{item.dd.week}}</span>
          <span>{{item.dd.dd}}</span>
        </div>
      </div>
      <div class="riitem riitems" @click="show=true">
        <div class="itemname">
          <div>更多日期</div>
          <div>
            <van-icon name="arrow" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="maxDate">
      <van-calendar v-model="show" color="#ffaa00" type="single" style="margin-bottom: 0;" :style="{ height: '65%' }"
        :default-date="selectDate" :formatter="formatter" :show-confirm="false" @confirm="onConfirm" :min-date="minDate"
        :max-date="maxDate">
        <template #top-info="item">
          <span style="color: #ff0000;">{{item.topInfo}}</span>
        </template>
      </van-calendar>
    </div>
  </div>
</template>

<script>
  import {
    Toast
  } from 'vant';
  export default {
    name: 'leoCalendar',
    props: {
      title: {
        type: String,
        default: '选择日期'
      },
      titlermark: {
        type: String,
        default: '请选择使用日期'
      },
      bgColor: {
        type: String,
        default: "#fff8f9"
      },
      deData: {
        type: Object,
        default: () => {
          return {
            defaultPrice: 0,
            defaultStock: 0,
            Dates: []
          }
        }
      },
      useDate: {
        type: String
      }
    },
    data() {
      return {
        show: false,
        prices: [],
        dateList: [],
        checkdate: '',
        sprice: '99',
        deDataList: this.deData,
        selectDate: null,
        minDate: null,
        maxDate: null,
      }
    },
    methods: {
      // click选中日期
      checkDate(item) {
        this.checkdate = item
        let dd = new Date(item.dd.date)
        this.selectDate = dd
        // 子组件中触发父组件方法并传值
        this.$emit('confirm', item)
      },
      // 日历弹出框选中
      onConfirm(date) {
        let that = this
        let dqdate = that.formatDate(date); // 返回日期格式
        let item = {
          dd: that.getWeek(dqdate)
        };
        //选择的时候是  存在 列表显示的 start
        let checkitem = ''
        for (var i = 0; i < that.dateList.length; i++) {
          if (item.dd.date == that.dateList[i].dd.date) {
            checkitem = that.dateList[i]
            break;
          }
        }
        if (checkitem == '') {
          that.checkdate = item
          that.dateList.splice(2, 1, item);
        } else {
          that.checkdate = checkitem
        }
        this.$emit('confirm', that.checkdate)
        //选择的时候是  存在 列表显示的 end
        that.show = false
      },
      // 日期格式
      formatDate(date) {
        return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
      },
      // 获取星期
      getWeek(date) {
        let myDate = new Date(date);
        let newDate = new Date();
        let newyy = String(newDate.getFullYear());
        let newmm = newDate.getMonth() + 1;
        let yy = String(myDate.getFullYear());
        let wk = myDate.getDay();
        let mm = myDate.getMonth() + 1;
        let dd = String(myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate());
        let weeks = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
        let tday = '';
        if (newyy == yy && newmm == mm) {
          if (newDate.getDate() - myDate.getDate() == 0) {
            tday = '今天'
          } else if (newDate.getDate() - myDate.getDate() == -1) {
            tday = '明天'
          }
        }
        let mmm = String(mm < 10 ? '0' + mm : mm);
        return {
          date: yy + '-' + mmm + '-' + dd,
          dd: mmm + '-' + dd,
          week: tday == '' ? weeks[wk] : tday
        };
      },
      GetDateStr(sdate, AddDayCount) {
        var dd = new Date();
        if (sdate != '') {
          dd = new Date(sdate);
        }
        dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期
        var y = dd.getFullYear();
        var m = dd.getMonth() + 1; //获取当前月份的日期
        var d = dd.getDate();
        m = String(m < 10 ? '0' + m : m);
        d = String(d < 10 ? '0' + d : d);
        return y + "-" + m + "-" + d;
      },
      // 日历
      formatter(day) {
        // day 当天
        let that = this
        let nn = that.GetDateStr(that.useDate, -1);
        if (that.compare(nn, day.date)) {
          day.type = 'disabled'
        }
        return day;
      },
      compare(d1, d2) {
        let ds1 = new Date(d1);
        let ds2 = new Date(d2);
        if (ds2 > ds1) {
          return false
        } else {
          return true
        }
      },

      //初始化日历
      initDate() {
        let that = this
        let ddlist = [];
        let minMax = that.deDataList.Dates;
        var len = minMax.length > 3 ? 3 : minMax.length;
        //设置了 就只能选择设置了的
        for (var i = 0; i < len; i++) {
          let obj = that.deDataList.Dates[i];
          ddlist.push({
            dd: that.getWeek(obj.date)
          })
        }
        that.dateList = ddlist;
        let last = minMax[minMax.length - 1];
        that.minDate = new Date();
        that.maxDate = new Date(last.date);
      }
    },
    mounted() {
      Toast.loading({
        message: '请稍后...',
        loadingType: 'spinner',
        forbidClick: true,
        duration: 0, //展示时长(ms)，值为 0 时，toast 不会消失
        className: 'leoloading'
      });
      setTimeout(() => {
        this.initDate();
        this.checkDate(this.dateList[0]); //默认选中第一天
        Toast.clear()
      }, 300);
    }
  }
</script>

<style lang="less">
  // 日期
  .rqbox {
    padding: 15px;

    .title {
      padding-bottom: 15px;

      .titlename {
        font-weight: 600;
      }

      .titletips {
        padding-left: 10px;
        font-size: 13px;
        color: #ff0000;

        .van-icon {
          padding-right: 5px;
        }
      }
    }

    .rqlist {
      display: flex;
      justify-content: space-between;

      .riitems {
        width: 48px;
        position: relative;
        display: flex;

        .itemname {
          display: flex;
          align-items: center;
        }
      }

      .riitem {
        padding: 10px 8px;
        border-radius: 8px;
        background-color: #ffffff;
        font-size: 14px;
        border: 1px solid #efefef;
        display: flex;
        align-items: center;

        .itemname {
          span:first-child {
            font-size: 13px;
            padding-right: 3px;
          }
        }
      }

      .riitem-active {
        background: linear-gradient(to right, #ffaa7f, #ffaa00);

      }
    }
  }
</style>
